// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__IhqCT","spin":"spinner_spin__+YiVN"};